import qs from 'qs';
import { IAsyncService } from '../context/IAsyncService';

enum AsyncServiceType {
  Generic = '1',
  Eureka = '2',
}

// Tipi di servizio da parsare. Per i tipi in questa lista sarà necessario aggiungere in
// testa il path /framework-cfg-utenti/proxy/ws-esterni/{idServizioEsterno}/
const serviceTypeToParse = [AsyncServiceType.Generic, AsyncServiceType.Eureka];

/**
 * Ritorna l'URL del service, modificato se necessario con la gestione
 * dell'ID servizio.
 */
function getServiceUrl(service: Pick<IAsyncService, 'id' | 'url' | 'type'>) {
  // Check per retrocompatibilità
  if (service.url.includes('{idServizioEsterno}')) {
    // Sostituiamo il placeholder {idServizioEsterno} con l'id del servizio
    return service.url.replace('{idServizioEsterno}', service.id);
  }

  // L'URL _non_ va modificato se è un servizio di tipo di tipo diverso da Generic o Eureka
  if (!serviceTypeToParse.includes(service.type.id as AsyncServiceType)) {
    return service.url;
  }

  return `/framework-cfg-utenti/proxy/ws-esterni/${service.id}${
    service.url.startsWith('/') ? service.url : `/${service.url}`
  }`;
}

/**
 * 1. Sostituiamo il placeholder {idServizioEsterno} con l'id del servizio
 * 2. In caso siano specificati dei parametri di input nella url del servizio,
 *    li estraiamo per utilizzarli nella chiamata come parametri di query
 *    "statici"
 */
export function parseAsyncServiceUrl(
  service: Pick<IAsyncService, 'id' | 'url' | 'type'>,
) {
  const serviceUrl = getServiceUrl(service);
  const [serviceUrlPath, serviceUrlParams] = serviceUrl.split('?');

  const originalParams = qs.parse(serviceUrlParams ?? '');

  return {
    url: serviceUrlPath,
    originalParams,
  };
}
